import {NgTemplateOutlet} from '@angular/common';
import {Component, Input, OnInit} from '@angular/core';
import {MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from '@angular/material/expansion';
import {MatTooltip} from '@angular/material/tooltip';
import {Router} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {BoardGroupModel, BoardTableModel} from '../../../models/tasktable.model';
import {TaskServiceService} from '../../../services/task-service.service';
import {ComponentsModule} from '../../components.module';

@Component({
    selector: 'app-task-dashboards-v2',
    standalone: true,
    imports: [
        MatAccordion,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        NgTemplateOutlet,
        TranslatePipe,
        ComponentsModule,
        MatTooltip
    ],
    templateUrl: './task-dashboards-v2.component.html',
    styleUrl: './task-dashboards-v2.component.scss'
})
export class TaskDashboardsV2Component implements OnInit {
    @Input() boards: BoardTableModel[];
    @Input() allGroups: BoardGroupModel[];

    constructor(
        private router: Router,
        private taskService: TaskServiceService,
    ) {
    }

    ngOnInit(): void {
        if (!this.boards && !this.allGroups) {
            this.getGroupsAndBoards();
        }
    }

    getGroupsAndBoards(): void {
        this.taskService.getAllBoards(false).then(res => {
            this.boards = res.boards;
            this.allGroups = res.groups;
        });
    }

    goTo(event: MouseEvent, board: BoardTableModel, road: 'settings' | 'table'): void {
        event.stopPropagation();
        if (road === 'settings') {
            void this.router.navigate(['account', 'tasks', 'options', 'statuses'], {queryParams: {alias: board.alias}});
        } else {
            this.taskService.setBoard(board.alias, true).then(() => {
                void this.router.navigate(['account', 'tasks', 'all', board.alias]);
            });
        }
    }
}
